













































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/UHeader.vue";
import ProgramingStartSection from "@/components/ProgramingStartSection.vue";
import Footer from "@/components/Footer.vue";
import CategoriesApi from "@/services/CategoriesApi";
import MaterialGroupApi from "@/services/MaterialGroups";
import { SortDirection, Category, MaterialGroupList } from "@/api/lab-base-api-client";
import { sortCreatedAt } from "@/utils/Util";

interface MaterialList {
  category: Category;
  materialGroups: MaterialGroupList[];
}

@Component({
  components: {
    Header,
    ProgramingStartSection,
    Footer,
  },
})
export default class Materials extends Vue {
  // category一覧
  private categories: Category[] = [];

  // materialGroup一覧
  private materialGroups: MaterialGroupList[] = [];

  // categoryId別の配列
  private materialLists: MaterialList[] = [];

  // ページ読み込み時に実行
  private async mounted() {
    await this.fetch();
    this.setMaterialList();
  }

  private async fetch() {
    // category一覧を取得
    const categoriesRes = await CategoriesApi.instance.getCategories();
    this.categories = categoriesRes.data.data.categories;
    // category一覧を作成日順に並び替え
    this.categories.sort(sortCreatedAt);

    // materialGroup一覧取得
    const materialGroupsRes = await MaterialGroupApi.instance.getMaterialGroup(
      undefined,
      undefined,
      SortDirection.Asc,
      undefined,
      undefined,
      true
    );
    const materialGroups = materialGroupsRes.data.data.items;
    if (!materialGroups) {
      return;
    }
    // categoryが存在するmaterialGroup一覧取得
    this.materialGroups = materialGroups.filter((materialGroup: { categories: {} }) => materialGroup.categories);
  }

  // categoryが属しているidごとにmaterialGroup分け
  private setMaterialList() {
    this.categories.forEach((category: Category) => {
      const materialGroups: MaterialGroupList[] = [];

      this.materialGroups.forEach((materialGroup: MaterialGroupList) => {
        for (let i = 0; i < materialGroup.categories.length; i += 1) {
          if (materialGroup.categories[i].id === category.id) {
            if (materialGroup.visibilityFlag || !materialGroup.materials) {
              return;
            }
            const materials = materialGroup.materials.filter((material: { deleted: boolean }) => !material.deleted);
            // sort順に並び替え
            materials.sort((a, b) => {
              if (a.sort > b.sort) {
                return 1;
              }
              return -1;
            });
            const materialMass = materialGroup;
            materialMass.materials = materials;
            materialGroups.push(materialMass);
          }
        }
      });
      this.materialLists.push({ category, materialGroups });
    });
  }
}
